/*
 * Copyright (c) 2020 General Electric Company. All rights reserved.
 *
 * The copyright to the computer software herein is the property of
 * General Electric Company. The software may be used and/or copied only
 * with the written permission of General Electric Company or in accordance
 * with the terms and conditions stipulated in the agreement/contract
 * under which the software has been supplied.
 */

import * as moment from 'moment';
import { ItemUpdate } from '@app/data-model/item-update';

export class StatusUpdate extends ItemUpdate {
  status: string;
  statusId: number;
  verifiedTimeOfExam: string;
  customClass: string;

  constructor(id, status, statusId, verifiedDateTime, customClass) {
    super(id);
    this.status = status;
    this.statusId = statusId;
    if (verifiedDateTime) {
      this.verifiedTimeOfExam = moment(verifiedDateTime, 'YYYY-MM-DD hh:mm:ss.SSSSSS').format(
        'YYYY-MM-DD HH:mm:ss.SSS'
      );
    } else {
      this.verifiedTimeOfExam = verifiedDateTime;
    }
    this.customClass = customClass;
  }
}
